// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecommendedVendorsCard_recommendedVendorsCard__Djxyp {
  background: #fbfbfb;
  border-radius: 12px;
  padding: 4px;
  display: flex;
  align-items: stretch;
  justify-content: start;
  gap: 7px;
  aspect-ratio: 380/177;
  max-width: 380px;
  min-width: 300px;
  width: 100%;
  flex: 0 0 auto;
}
@media (max-width: 450px) {
  .RecommendedVendorsCard_recommendedVendorsCard__Djxyp {
    flex-direction: column;
  }
}
.RecommendedVendorsCard_recommendedVendorsCard__Djxyp .RecommendedVendorsCard_recommendedVendorsCardImage__LRAUg {
  border-radius: 12px;
  aspect-ratio: 178/169;
  max-width: 178px;
  width: 100%;
  overflow: hidden;
}
@media (max-width: 450px) {
  .RecommendedVendorsCard_recommendedVendorsCard__Djxyp .RecommendedVendorsCard_recommendedVendorsCardImage__LRAUg {
    aspect-ratio: 179/123;
    max-width: 100%;
  }
}
.RecommendedVendorsCard_recommendedVendorsCard__Djxyp .RecommendedVendorsCard_recommendedVendorsCardImage__LRAUg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.RecommendedVendorsCard_recommendedVendorsCard__Djxyp .RecommendedVendorsCard_recommendedVendorsCardContent__4AWG8 {
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
  padding: 8px 0;
  padding-right: 3px;
}
@media (max-width: 450px) {
  .RecommendedVendorsCard_recommendedVendorsCard__Djxyp .RecommendedVendorsCard_recommendedVendorsCardContent__4AWG8 {
    padding: 0;
  }
}
.RecommendedVendorsCard_recommendedVendorsCard__Djxyp .RecommendedVendorsCard_recommendedVendorsCardContent__4AWG8 .RecommendedVendorsCard_recommendedVendorsCardContentText__yji2\\+ {
  width: 100%;
}
.RecommendedVendorsCard_recommendedVendorsCard__Djxyp .RecommendedVendorsCard_recommendedVendorsCardContent__4AWG8 .RecommendedVendorsCard_recommendedVendorsCardContentText__yji2\\+ h4 {
  font: var(--body-font-one);
  color: var(--primary-Text);
  font-weight: 600;
}
.RecommendedVendorsCard_recommendedVendorsCard__Djxyp .RecommendedVendorsCard_recommendedVendorsCardContent__4AWG8 .RecommendedVendorsCard_recommendedVendorsCardContentText__yji2\\+ p {
  color: var(--secondary-Text);
  font: var(--body-font-four);
  letter-spacing: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/UserDashboard/RecommendedVendors/RecommendedVendorsCard.module.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,QAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AACD;AAKC;EAlBD;IAmBE,sBAAA;EAFA;AACF;AAIC;EACC,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAFF;AAIE;EAPD;IAQE,qBAAA;IACA,eAAA;EADD;AACF;AAGE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AADH;AAKC;EACC,WAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;AAHF;AAKE;EAVD;IAWE,UAAA;EAFD;AACF;AAIE;EACC,WAAA;AAFH;AAIG;EACC,0BAAA;EACA,0BAAA;EACA,gBAAA;AAFJ;AAKG;EACC,4BAAA;EACA,2BAAA;EACA,mBAAA;AAHJ","sourcesContent":[".recommendedVendorsCard {\r\n\tbackground: #fbfbfb;\r\n\tborder-radius: 12px;\r\n\tpadding: 4px;\r\n\tdisplay: flex;\r\n\talign-items: stretch;\r\n\tjustify-content: start;\r\n\tgap: 7px;\r\n\taspect-ratio: 380 / 177;\r\n\tmax-width: 380px;\r\n\tmin-width: 300px;\r\n\twidth: 100%;\r\n\tflex: 0 0 auto;\r\n\r\n\t// @media (max-width: 599px) {\r\n\t//     aspect-ratio: 178 / 169;\r\n\t//     max-width: 178px;\r\n\t// }\r\n\t@media (max-width: 450px) {\r\n\t\tflex-direction: column;\r\n\t}\r\n\r\n\t.recommendedVendorsCardImage {\r\n\t\tborder-radius: 12px;\r\n\t\taspect-ratio: 178 / 169;\r\n\t\tmax-width: 178px;\r\n\t\twidth: 100%;\r\n\t\toverflow: hidden;\r\n\r\n\t\t@media (max-width: 450px) {\r\n\t\t\taspect-ratio: 179 / 123;\r\n\t\t\tmax-width: calc(100%);\r\n\t\t}\r\n\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tobject-fit: cover;\r\n\t\t}\r\n\t}\r\n\r\n\t.recommendedVendorsCardContent {\r\n\t\twidth: 100%;\r\n\t\tdisplay: flex;\r\n\t\talign-items: end;\r\n\t\tjustify-content: space-between;\r\n\t\tflex-direction: column;\r\n\t\tgap: 10px;\r\n\t\tpadding: 8px 0;\r\n\t\tpadding-right: 3px;\r\n\r\n\t\t@media (max-width: 450px) {\r\n\t\t\tpadding: 0;\r\n\t\t}\r\n\r\n\t\t.recommendedVendorsCardContentText {\r\n\t\t\twidth: 100%;\r\n\r\n\t\t\th4 {\r\n\t\t\t\tfont: var(--body-font-one);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t}\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tletter-spacing: 2px;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"recommendedVendorsCard": `RecommendedVendorsCard_recommendedVendorsCard__Djxyp`,
	"recommendedVendorsCardImage": `RecommendedVendorsCard_recommendedVendorsCardImage__LRAUg`,
	"recommendedVendorsCardContent": `RecommendedVendorsCard_recommendedVendorsCardContent__4AWG8`,
	"recommendedVendorsCardContentText": `RecommendedVendorsCard_recommendedVendorsCardContentText__yji2+`
};
export default ___CSS_LOADER_EXPORT___;
